<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="venues-in-range">
  <span *ngIf="coordinates['lat'] && coordinates['lat'] != 00 && coordinates['long'] && coordinates['long'] !== 0">
    <input
      placeholder="{{ 'VENUES_IN_RANGE.KM' | translate }}"
      type="number"
      #venuesInRange
      class="form-control range-input"
    />
    <button
      type="button"
      class="btn btn-primary btn-ico"
      [ngbTooltip]="'VENUES_IN_RANGE.ADD_IN_RANGE' | translate"
      (click)="findVenuesInRange(venuesInRange.value)"
    >
      <i class="fal fa-dot-circle"></i>
    </button>
  </span>

  <button
    type="button"
    class="btn btn-primary btn-ico"
    (click)="addVenuesFromCity()"
    [ngbTooltip]="'VENUES_IN_RANGE.ADD_ALL_FROM_CITY' | translate"
    *ngIf="this.city_id"
  >
    <i class="fal fa-city"></i>
  </button>
</div>
